import { OnEventDispatcher } from './on-event-dispatcher';
export type StateManagerEventData = {
    path:string,
    parts:string[]
}
export class StateManager extends OnEventDispatcher {
    private _path:string = "";
    private _parts: string[];
    private firstUpdate:boolean = true;
    constructor() {
        super();
    }
    public init():Promise<void> {
        return new Promise((resolve, reject) => {
            window.addEventListener("popstate", (event) => {
                this.onPopState(event);
            }, true);
            this.update();
            resolve();
        });
    }
    private update() {
        let cPath:string = window.location.pathname;
        if(cPath!=null&&cPath.length>0&&cPath.charAt(cPath.length-1)=="/") cPath=cPath.substr(0, cPath.length-1);
        if(this.firstUpdate||cPath!=this._path) {
            this.firstUpdate = false;
            this._path = cPath;
            this._parts = this.splitPath(this._path);
            let evData:StateManagerEventData = {
                path: this._path,
                parts: this._parts
            }
            this.dispatch("change", evData);
        }
    }
    public get parts():string[] {
        return this._parts;
    }
    public get path():string {
        return this._path;
    }
    private onPopState(event:PopStateEvent) {
        this.update();
    }
    public setPath(path:string) {
        if(path.charAt(0)!="/") path = "/"+path;
        window.history.pushState({}, null, path);
        this.update();
    }
    public splitPath(path:string):Array<string> {
        let spl:Array<string> = path.split("/");
        return spl.filter((v:string) => {return v!=""})
    }
}